export enum SIDE_PANEL_MODE {
    LOADING = 'loading',
    ASSIGNMENT = 'assignment',
    REASSIGNMENT = 'reassignment',
    LESSON_STATS = 'lesson_stats',
    COPY = 'copy',
    COPY_AS_RNO = 'copy_as_rno',
    AFTER_COPYING = 'after_copying',
}
